import React, { createContext, useContext, useState, useEffect } from "react";
import { EdgeToEdge } from "@capawesome/capacitor-android-edge-to-edge-support";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme === "dark";
  });

  const setBackgroundColor = async (color) => {
    // Only call Capacitor plugins on native platforms
    if (Capacitor.isNativePlatform()) {
      try {
        await EdgeToEdge.setBackgroundColor({ color });
        await StatusBar.setStyle({
          style: isDarkMode || color === "#000000" ? Style.Dark : Style.Light,
        });
      } catch (error) {
        console.warn("Failed to set native theme:", error);
      }
    }
  };

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
      setBackgroundColor("#000000");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
      setBackgroundColor("#ffffff");
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
